module.exports = __webpack_public_path__ + "static/media/login_btn1.dbc71aff.svg";